import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import { AccessMenuItem } from '../access-selector/access-selector.component';
import { CollectionAccessLevel } from '@mode/shared/contract-common';
import { capraIconBuildingEdit, capraIconBuildingView, capraIconLock } from '@mode/capra';
import { HelpDocsService } from '@mode/shared/util-js';

@Component({
  selector: 'mode-workspace-access-selector',
  templateUrl: './workspace-access-selector.component.html',
  styleUrls: ['./workspace-access-selector.component.scss'],
})
export class WorkspaceAccessSelectorComponent implements OnChanges {
  @Input()
  isContentPersonal: boolean;

  @Input()
  selected = '';

  @Output()
  selection = new EventEmitter<Partial<AccessMenuItem>>();

  entitlementIcon: string;
  selectedItem: Partial<AccessMenuItem> = {};

  constructor(public helpDocs: HelpDocsService) {
    this.setIcon(this.selected);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selected && changes.selected.currentValue !== changes.selected.previousValue) {
      this.setIcon(changes.selected.currentValue);
    }
  }

  entitlementChange(menuItem: Partial<AccessMenuItem>) {
    this.selectedItem = menuItem;
    this.setIcon(this.selectedItem.id);

    this.selection.emit(this.selectedItem);
  }

  setIcon(entitlementLevel: string) {
    if (entitlementLevel === CollectionAccessLevel.View) {
      this.entitlementIcon = capraIconBuildingView.name;
    } else if (entitlementLevel === CollectionAccessLevel.Edit) {
      this.entitlementIcon = capraIconBuildingEdit.name;
    } else {
      this.entitlementIcon = capraIconLock.name;
    }
  }
}
